import { ReactComponent as MakeShorterIcon } from 'assets/icons/designAi/make_shorter.svg';
import { ReactComponent as MakeProfessionalIcon } from 'assets/icons/designAi/professional.svg';
import { ReactComponent as SpellcheckIcon } from 'assets/icons/designAi/spellcheck.svg';

const DEFAULT_PROMPTS = [
  {
    label: 'defaultPrompts.makeShorter',
    instructions: 'Shorten the text.',
    icon: <MakeShorterIcon />,
  },
  {
    label: 'defaultPrompts.makeProfessional',
    instructions: 'Make text more professional.',
    icon: <MakeProfessionalIcon />,
  },
  {
    label: 'defaultPrompts.spellingGrammar',
    instructions: 'Fix spelling and grammar. Do not make any other changes.',
    icon: <SpellcheckIcon />,
  },
];

// Response retrieved from /generateText endpoint to indicate the end of the generation
const GENERATE_TEXT_TERMINATOR = '[DONE]';

// Limit on text input field
const MAX_CUSTOM_INPUT_LENGTH = 255;

// When adding new text from generation, distance below the current text widget
const NEW_TEXT_PADDING = 10;

// Threshold to use with useRelativeWidgetPosition hoook
// Need at leastt 400px above widget to place above
// Need at least 250px below to place below
const MODAL_THRESHOLD = [400, 250];
const START_MODAL_HEIGHT = 110;
const MODAL_WIDTH = 572;

// Scroll threshold when determining the modal position
// If widget is below SCROLL_THRESHOLD * window.innerHeight, will scroll the widget into view
const SCROLL_THRESHOLD = 0.7;

const DEFAULT_BUTTON_PROPS = {
  size: 'xs',
  fontSize: 'xs',
  borderRadius: 'base',
  p: 3.5,
  fontWeight: '500',
};

const GENERATION_DISCARD_TEXT = 'ImproveText';

export {
  DEFAULT_PROMPTS,
  NEW_TEXT_PADDING,
  GENERATE_TEXT_TERMINATOR,
  MAX_CUSTOM_INPUT_LENGTH,
  MODAL_THRESHOLD,
  START_MODAL_HEIGHT,
  DEFAULT_BUTTON_PROPS,
  MODAL_WIDTH,
  SCROLL_THRESHOLD,
  GENERATION_DISCARD_TEXT,
};
